import React, { useEffect, useState } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

interface MoneyInputProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: Function;
  currency?: string;
  round?: boolean
}

export const MoneyInput = ({
  min = 0,
  max = 50000,
  value = 0,
  currency = '$',
  round = true,
  onChange = () => {}
}: MoneyInputProps) => {
  const [checkedValue, setCheckedValue] = useState(value);
  const [localValue, setLocalValue] = useState(value);

  const checkBounds = value => {
    if (value > max) {
      setCheckedValue(max);
      setLocalValue(max);
      return;
    }
    if (value < min) {
      setCheckedValue(min);
      setLocalValue(min);
      return;
    }
    value = round ? Math.round(value) : value
    setCheckedValue(value);
    value != localValue && setLocalValue(value);
  };

  useEffect(() => {
    checkBounds(value);
  }, [value]);

  useEffect(() => {
    value != checkedValue && onChange(checkedValue);
  }, [checkedValue]);

  return (
    <InputGroup className="mb-3" size="lg">
      <InputGroup.Text className="">{currency}</InputGroup.Text>
      <FormControl
        key={value}
        id="money-input"
        className="px-3"
        type="number"
        min={min}
        max={max}
        step="1"
        value={localValue}
        onChange={e => {
          setLocalValue(Number(e.currentTarget.value));
        }}
        onBlur={() => {
          checkBounds(localValue);
        }}
        data-testid="MoneyInput"
      />
    </InputGroup>
  );
};
